import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('ep-timeline')
export class EPTimeline extends LitElement {

  render() {
    return html`
      <div class="timeline-wrapper">
        <div class="timeline">
          <slot></slot>
        </div>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      --timeline-padding: 60px;
      --border-muted: rgb(216, 222, 228);
      --border-default: rgb(208, 215, 222);
      --badge-background: rgb(234, 238, 242);
      --canvas-subtle: rgb(246, 248, 250);
      --font-prose: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
      font-family: var(--font-prose);
    }

    .timeline-wrapper {
      padding-left: var(--timeline-padding);
    }

    .timeline {
      display: flex;
      flex-direction: column;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-timeline': EPTimeline
  }
}
